import React from 'react';
import { Link } from 'react-router-dom';
import { FiShoppingCart, FiMaximize2, FiGrid, FiAward } from 'react-icons/fi';
import { FaPalette } from 'react-icons/fa';
import carpet from '../../../assets/img/default/carpet.svg';
import language from './lang';

const product = ({ data, lang, currency, rate, redirect, list, index }) => {
    const { sale, empty } = language[lang || 'en'];
    const price = currency === 'UZS' ? parseInt(parseFloat(data.totalMerchantPrice) * rate) : data.totalMerchantPrice;

    if (list) {
        return (

            <tr onClick={() => redirect(data.id)} className="hover">
                <th>{index}</th>
                <td>
                    <img src={data.img || carpet} alt={data.name} width="30" />
                </td>
                <td className="text-capitalize">{data.name}</td>
                <td><p className="card-text"><FiGrid /> <b>{data.code || '0'}</b></p></td>
                <td><p className="card-text"><FiMaximize2 className="dimensions-icon" /> <b>{data.dimensions || 'N/A'}</b></p></td>
                <td className="text-capitalize"><FiAward /> {data.quality}</td>
                <td><p className="card-text"><FiShoppingCart /> <b>{data.roll > 0 ? (data.piece || '0') + ' m' : data.piece || '0'}</b></p></td>
                <td><p className="card-text"><FaPalette color={data.coloCode} fill={data.colorCode || 'var(--success)'} /> {data.color}</p></td>
                <td>
                    {
                        data.piece > 0 ?
                            (<Link to={'/sales/' + data.id + '/sale'} className="btn btn-success d-block btn-sm mx-auto rounded-pill w-100 px-4" onClick={(e) => e.stopPropagation()}><small>{currency}</small> {price.toLocaleString()}</Link>)
                            :
                            <button className="btn btn-danger btn-sm d-block rounded-pill mx-auto w-100 px-4">{empty}</button>
                    }
                </td>
            </tr>
        )
    } else {
        return (
            <div className="card product-item">
                <Link to={'/products/' + data.id} className="text-dark">
                    <div className="gal-img-wrapper" style={{ backgroundImage: `url(${data.img || carpet})` }}>
                    </div>
                    <div>
                        <h3 className="card-title">{data.name}</h3>
                        {/* <p className="card-text">Size: <b>{data.dimensions || 'N/A'}</b></p> */}
                        <div className="d-flex justify-content-between product-cart-content">
                            <p className="card-text"><FiGrid /> <b>{data.code || '0'}</b></p> |
                        <p className="card-text"><FiMaximize2 className="dimensions-icon" /> <b>{data.dimensions || 'N/A'}</b></p> |
                        <p className="card-text"><FaPalette color={data.coloCode} fill={data.colorCode || 'var(--success)'} /> {data.color}</p>
                            | <p className="card-text"><FiShoppingCart /> <b>{data.piece || '0'}</b></p>
                        </div>
                    </div>
                </Link>
                <div className="card-call-action">
                    <h4 className="card-price">{price.toLocaleString()}<sup className="currency">{currency}</sup></h4>
                    {
                        data.piece > 0 ?
                            (<Link to={'/sales/' + data.id + '/sale'} className="btn btn-success d-block btn-sm mx-auto rounded-pill w-100 px-4">{sale}</Link>)
                            :
                            <button className="btn btn-danger btn-sm rounded-pill mx-auto d-block w-100 px-4">{empty}</button>
                    }
                </div>
            </div>
        )
    }

}

export default product;